import React from 'react';

import type { TableWidgetData } from '@/features/_shared/widget-registry';
import { WIDGET_TYPES, widgetRegistry } from '@/features/_shared/widget-registry';
import type { ToolResultContentPart } from '@/features/ai-chat/types/chat.types';

const WidgetMapper = ({ widgetData }: { widgetData: ToolResultContentPart }) => {
  if (widgetData.display === 'table') {
    const TableWidget = widgetRegistry.resolve<{ data: TableWidgetData }>(WIDGET_TYPES.TABLE);
    if (TableWidget) return <TableWidget data={widgetData} />;
  }
  return null;
};

export default React.memo(WidgetMapper);
